/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { AppFormModel } from '../models/AppFormModel';
import { BasicViewService } from "../../../../../shared/services/BasicViewService";

export class AppViewService extends BasicViewService<LocalAppDefinition> {

	private readonly submitSelector = ".js-submit-form";

	constructor(parent: StepController, options: BasicAppOptions<LocalAppDefinition>, loader: BasicLoader<LocalAppDefinition>) {
		super(parent, options, loader);
		this.formId = 'dsgvoreport';
	}

	public addOverviewPageListener(requestInformationListener: (e: JQuery.Event) => void): void {
		this.$ctx.find(this.submitSelector).on('click', requestInformationListener);
	}
	/**
	 * adds listeners to form
	 */
	public addListeners(handler: StandardViewEvents): void {
		const $form = this.getForm();

		// init form listener
		$form.find('input, select, textarea').on('change', handler.viewChangeListener.bind(handler));
		this.$ctx.find(this.submitSelector).on('click', handler.submitListener.bind(handler));

		// init all form elements from ew72
		S.Utils.FormAside.init();
		AppUtils.View.initFormElements();
	}

	public hideRequestInformationBtn(): void {
		this.$ctx.find(this.submitSelector).toggleClass('h-hidden', true);
	}

	public getFormModelFromView(): AppFormModel {
		const formData = this.getFormData();

		const appFormModel = new AppFormModel();
		appFormModel.Delivery = formData.Delivery;

		if (appFormModel.Delivery === "1") {
			appFormModel.Email = "";
		}
		else {
			appFormModel.Email = formData.Email;
		}

		return appFormModel;
	}

	public returnMainContentForApi(): string {
		return $('#l_main_content').clone().html();
	}
}